import { CodeIcon } from '@heroicons/react/solid';
import PropTypes from 'prop-types';
import React from 'react';
import { checkEmpty } from '@/utils/commonFunctions';
import RenderRepo from './RenderRepo';
import { StyledContainer, StyledRepoWrapper } from './styles';

export default function Projects({ repos }) {
  return (
    <StyledContainer id="projects" className="text-gray-400 bg-gray-900 body-font px-4 py-10 mx-auto">
      <div className="flex items-center mb-6">
        <CodeIcon className="w-10 inline-block mr-4" />
        <h1 className="sm:text-4xl text-3xl font-medium title-font text-white">Apps I&apos;ve Built</h1>
      </div>
      <StyledRepoWrapper>{!checkEmpty(repos) ? repos.map((repo) => <RenderRepo repo={repo} key={repo?.id} />) : null}</StyledRepoWrapper>
    </StyledContainer>
  );
}

Projects.propTypes = {
  repos: PropTypes.oneOfType([PropTypes.array]).isRequired,
};
